import { Box, Typography, Container, Stack } from '@mui/material';

export default function HowItWorksBanking() {
  const steps = [
    {
      number: '1',
      title: 'Register',
      description: 'Register yourself as a payfast application user'
    },
    {
      number: '2',
      title: 'Add new card',
      description: 'Card for you to use anytime and anywhere'
    },
    {
      number: '3',
      title: 'Success',
      description: 'Use payfast in peace and all its facilities'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h2" align="center" gutterBottom>
        How it works
      </Typography>
      
      <Stack 
        direction={{ xs: 'column', md: 'row' }} 
        spacing={4} 
        alignItems="center" 
        justifyContent="space-between"
        sx={{ mt: 6 }}
      >
        {steps.map((step, index) => (
          <Box 
            key={step.number}
            sx={{ 
              textAlign: 'center',
              position: 'relative',
              flex: 1
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                bgcolor: 'black',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto',
                mb: 2,
                fontSize: '1.25rem'
              }}
            >
              {step.number}
            </Box>
            
            {index < steps.length - 1 && (
              <Box
                sx={{
                  position: { md: 'absolute' },
                  top: { md: 24 },
                  left: { md: '60%' },
                  width: { md: '100%' },
                  height: { xs: 20, md: 2 },
                  borderTop: { md: '2px dashed #ccc' },
                  borderLeft: { xs: '2px dashed #ccc', md: 'none' },
                  display: { xs: 'block', md: 'block' },
                  ml: { xs: 'calc(24px + 0.5rem)', md: 0 }
                }}
              />
            )}

            <Typography variant="h6" gutterBottom>
              {step.title}
            </Typography>
            <Typography color="text.secondary">
              {step.description}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Container>
  );
}
